import LegalLayout, { H2, UL } from "@/components/layout/LegalLayout";

export default function ApiTerms() {
  return (
    <LegalLayout titleKey="apiTerms" title="API Terms of Service" testId="legal-api-terms-page">
      <H2>Overview</H2>
      <p>These API Terms govern use of AtlasForge Financial APIs and developer services.</p>

      <H2>API Access</H2>
      <p>Access may require:</p>
      <UL items={["Registration", "API credentials", "Approval processes", "Compliance reviews"]} />

      <H2>License</H2>
      <p>AtlasForge grants a limited, non-exclusive, revocable license to access and use the APIs in accordance with these Terms.</p>

      <H2>Restrictions</H2>
      <p>You may not:</p>
      <UL items={["Reverse engineer APIs", "Circumvent security controls", "Exceed rate limits", "Use APIs for unlawful purposes", "Create competing services using proprietary API functionality"]} />

      <H2>Data Responsibilities</H2>
      <p>Developers are responsible for:</p>
      <UL items={["Protecting customer information", "Maintaining appropriate security controls", "Complying with privacy laws", "Obtaining required user consent"]} />

      <H2>Availability</H2>
      <p>AtlasForge does not guarantee uninterrupted API availability and may modify or discontinue endpoints at any time.</p>

      <H2>Security Requirements</H2>
      <p>Developers must:</p>
      <UL items={["Protect API credentials", "Implement encryption", "Report security incidents promptly"]} />

      <H2>Termination</H2>
      <p>AtlasForge may revoke API access at any time for violations of these Terms.</p>

      <H2>Contact</H2>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>843-291-2556</p>
    </LegalLayout>
  );
}
